export default "__VITE_ASSET__BWaK7erO__"